import { GET_ALL_MAIN_BANNER_FAILURE, GET_ALL_MAIN_BANNER_REQUEST, GET_ALL_MAIN_BANNER_SUCCESS, GET_ALL_SIDE_BANNER_FAILURE, GET_ALL_SIDE_BANNER_REQUEST, GET_ALL_SIDE_BANNER_SUCCESS } from "./ActionType";

const initialState = {
  main: [],
  side: [],
  loading: false,
  error: "",
};

export const publicBannerReducer = (state = initialState, action) => {
  switch (action.type) {
    
    case GET_ALL_MAIN_BANNER_REQUEST:
      return { ...state, loading: true };

    case GET_ALL_MAIN_BANNER_SUCCESS:
      return { ...state, loading: false, error: "", main: action.payload };

    case GET_ALL_MAIN_BANNER_FAILURE:
      return { ...state, loading: false, error: action.payload };

      case GET_ALL_SIDE_BANNER_REQUEST:
      return { ...state, loading: true };

    case GET_ALL_SIDE_BANNER_SUCCESS:
      return { ...state, loading: false, error: "", side: action.payload };

    case GET_ALL_SIDE_BANNER_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
